export default __webpack_public_path__ + "static/media/score_tracking_mockup.0beb931f.png";